module.exports = __webpack_public_path__ + "static/img/second_product.cc8a388.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/second_product.png
// module id = /+Nb
// module chunks = 0